<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    fullscreen
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card tile>
      <v-toolbar dense>
        <v-btn @click="closeDialog()" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="subtitle-1">Contact List</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="sendAnalysesReport()" :loading="isSendingReport" :disabled="selected.length < 1">
          <v-badge color="primary darken-4" bordered :content="totalItems" overlap>
            <v-icon size="25">mdi-send</v-icon>
          </v-badge>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mx-0 px-0">
        <v-data-table
          v-model="selected"
          :fixed-header="true"
          :headers="headers"
          :items="contacts"
          show-select
          single-expand
          item-key="id"
          class="elevation-1"
          height="65vh"
          :items-per-page="100"
          :footer-props="{
            'items-per-page-options': [100]
          }"
          :search="search"
        >
          <template v-slot:top>
            <div class="d-flex">
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                color="primary darken-4"
                single-line
                hide-details
                filled
                clearable
              ></v-text-field>
            </div>

            <v-divider v-show="isCustomizedTable"></v-divider>
          </template>

          <template v-slot:item.name="{ item }">
            <div class="mx-auto" v-text="item.name"></div>
          </template>

          <template v-slot:item.phone="{ item }">
            <div class="mx-auto" v-text="item.phone"></div>
          </template>

          <template v-slot:item.email="{ item }">
            <div class="mx-auto" v-text="item.email"></div>
          </template>
        </v-data-table>
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AnalysesReportContactListDialog",
  data() {
    return {
      search: "",
      selected: [],
      isSendingReport: false, 

      headers: [
        { text: "Name", align: "center", value: "name" },
        { text: "Phone", align: "center", value: "phone", sortable: false },
        { text: "Email", align: "center", value: "email" }
      ]
    };
  },

  components: {},

  methods: {
    closeDialog() {
      this.$store.commit("setAnalysesReportContactListDialog", false);
    },

    sendAnalysesReport() {
      this.isSendingReport = true;

    this.$store.dispatch("sendAnalysesReport", this.selected).finally(() => {
      this.isSendingReport = false;
      this.selected = [];
    });
    }
  },

  watch: {},

  computed: {
    showDialog() {
      return this.$store.state.analyses.analysesReportContactListDialog;
    },

    isCustomizedTable() {
      return true;
    },

    contacts() {
      return this.$store.state.contacts.contacts;
    },

    totalItems() {
      return this.selected.length.toString();
    }
  }
};
</script>

<style>
</style>